import React from "react";
import { Box, Stack } from "@mui/material";
import AppStoreButtonImage from "url:src/assets/images/app-store-button.webp";
import GoogelPlayButtonImage from "url:src/assets/images/google-play-button.webp";
import LetsDlImage from "url:src/assets/images/lets_dl.png";
import { detectOS } from "src/utils/detect";

export default function AppDownloadCta() {
  return (
    <Stack direction="column" alignItems="center" gap={2}>
      <img src={LetsDlImage} alt="Lets Download App" style={{ display: "block", margin: "0 auto", width: "274px" }} />
      {detectOS() === "ios" ? (
        <a href="https://propally.go.link?adj_t=1o84fkrk" target="_blank" rel="noreferrer">
          <Box
            component="img"
            className="cv-btn01"
            src={AppStoreButtonImage}
            alt="AppStoreからダウンロード"
            sx={{
              height: "80px",
            }}
          />
        </a>
      ) : (
        <a href="https://propally.go.link?adj_t=1o84fkrk" target="_blank" rel="noreferrer">
          <Box
            component="img"
            className="cv-btn02"
            src={GoogelPlayButtonImage}
            alt="Google Playで手に入れよう"
            sx={{
              height: "80px",
            }}
          />
        </a>
      )}
    </Stack>
  );
}
